import React from "react";
import {useTheme,} from "@mui/material";
import styles from './available-spots.module.css'
import SpotsItem from "./spots-item";

interface Spot {
    id: number;
    ageRange: string;
    ageGroup: string;
    availability: string;
    isAvailable: boolean;
    cta: string;
}

const spots: Spot[] = [
    {
        id: 1,
        ageRange: "(9 - 18 mois)",
        ageGroup: "Nourrisson",
        availability: "Complete",
        isAvailable: true,
        cta: "Joindre Maintenant"
    },
    {
        id: 2,
        ageRange: "(18 mois - 3 ans)",
        ageGroup: "Tout-Petits",
        availability: "Complete",
        isAvailable: true,
        cta: "Joindre Liste D’attente"
    },
    {
        id: 3,
        ageRange: "(3 ans - 5 ans)",
        ageGroup: "Préscolaire",
        availability: "Complete",
        isAvailable: false,
        cta:"Joindre Maintenant"
    },
];

const AvailableSpots: React.FC = () => {
    const theme = useTheme();
    // const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <section className={styles.section_container}>
            <div className={styles.content_wrapper}>
                <div className={styles.image_container}>
                    <img
                        src="/images/home/available-spots-left.jpg"
                        alt="Espace chaleureux de la garderie"
                        className={styles.image}
                    />
                </div>
                <div className={styles.spots_item_container}>
                    <h2 className={styles.section_title}>
                        Places Disponibles
                    </h2>
                </div>
                <div className={styles.image_container}>
                    <img
                        src="/images/home/available-spots-right.jpg"
                        alt="Espace chaleureux de la garderie"
                        className={styles.image}
                    />
                </div>
                    {spots.map((item, index) => (
                        <div key={index} className={styles.spots_item_container}>
                            <SpotsItem
                                ageRange={item.ageRange}
                                ageGroup={item.ageGroup}
                                availability={item.availability}
                                group={item.ageRange}
                                cta={item.cta}
                             />
                        </div>
                    ))}

            </div>
        </section>
    );
};

export default AvailableSpots;
